// ============================================================
// Clase Usuario – mapea exactamente el response del backend
// ============================================================

export type UserRol = 'ADMIN' | 'DIRECTOR' | 'DOCENTE' | 'ESTUDIANTE' | 'PADRE' | 'SECRETARIA' | 'AUXILIAR' | 'PSICOLOGO';

export class User {
  // Campos de autenticación
  token: string;
  tipoToken: string;
  expiracionMs: number;

  // Campos de identidad
  idUsuario: number;
  username: string;
  nombres: string;
  apellidos: string;
  email: string;
  dni: string;
  telefono: string;
  fotoPerfil: string | null;

  // Campos de acceso
  rol: UserRol;
  ultimoAcceso: string;

  constructor(data: {
    token: string;
    tipoToken: string;
    expiracionMs: number;
    idUsuario: number;
    username: string;
    nombres: string;
    apellidos: string;
    email: string;
    dni: string;
    telefono: string;
    fotoPerfil: string | null;
    rol: UserRol;
    ultimoAcceso: string;
  }) {
    this.token        = data.token;
    this.tipoToken    = data.tipoToken;
    this.expiracionMs = data.expiracionMs;
    this.idUsuario    = data.idUsuario;
    this.username     = data.username;
    this.nombres      = data.nombres;
    this.apellidos    = data.apellidos;
    this.email        = data.email;
    this.dni          = data.dni;
    this.telefono     = data.telefono;
    this.fotoPerfil   = data.fotoPerfil;
    this.rol          = data.rol;
    this.ultimoAcceso = data.ultimoAcceso;
  }

  // ── Helpers ────────────────────────────────────────────────

  /** Nombre completo */
  getNombreCompleto(): string {
    return `${this.nombres} ${this.apellidos}`;
  }

  /** Header Authorization listo para usar en fetch */
  getAuthHeader(): string {
    return `${this.tipoToken} ${this.token}`;
  }

  /** Verifica si el token sigue vigente */
  tokenVigente(): boolean {
    const stored = localStorage.getItem('auth_issued_at');
    if (!stored) return false;
    const issuedAt = parseInt(stored, 10);
    return Date.now() - issuedAt < this.expiracionMs;
  }

  /** Construye un User desde el campo `data` del response exitoso */
  static fromApiResponse(data: Record<string, unknown>): User {
    return new User({
      token:        data.token        as string,
      tipoToken:    data.tipoToken    as string,
      expiracionMs: data.expiracionMs as number,
      idUsuario:    data.idUsuario    as number,
      username:     data.username     as string,
      nombres:      data.nombres      as string,
      apellidos:    data.apellidos    as string,
      email:        data.email        as string,
      dni:          data.dni          as string,
      telefono:     data.telefono     as string,
      fotoPerfil:   data.fotoPerfil   as string | null,
      rol:          data.rol          as UserRol,
      ultimoAcceso: data.ultimoAcceso as string,
    });
  }
}